import { SolicitacaoTecnicaService } from "./../../../../services/solicitacao-tecnica.service";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
	MatDialog,
	MatDialogConfig,
	MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IPeaUnidadeGestoraModel } from "src/app/models/pea-unidade-gestora.model";
import { IUnidadeGestoraModel } from "src/app/models/unidade-gestora.model";
import { ModalSelecionarUgComponent } from "src/app/pages/pea-form/modal-selecionar-ug/modal-selecionar-ug.component";
import { UnidadeGestoraService } from "src/app/services/unidade-gestora.service";
import { defaultDataAcessor } from "src/app/core/helpers/mat-sort-data-accessor";
import { ModalCancelarComponent } from "../../modal-cancelar/modal-cancelar-component";
import { IAmostraModel } from "src/app/models/amostra.model";
import { IAmostraUnidadeGestora } from "src/app/models/amostra-unidade-gestoras.model";
import { AmostraService } from "src/app/services/amostra.service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { IEnumModel } from "../../../../models/enum.model";
import { IPlanejamentoAmostraMatrizQuestaoModel } from "../../../../models/planejamento-amosta-matriz-questoes.model";
import * as XLSX from "xlsx";
import { BaseFormComponent } from "../../base-form/base-form.component";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ModalAmostraFormularioComponent } from "../modal-amostra-formulario/modal-amostra-formulario.component";
import { IAmostraFormulario } from "../../../../models/amostra-formulario.model";

@Component({
	selector: "app-inserir-amostra",
	templateUrl: "./inserir-amostra.component.html",
	styleUrls: ["./inserir-amostra.component.scss"],
})
export class InserirAmostraComponent
	extends BaseFormComponent
	implements OnInit
{
	public id!: number;
	public unidadeGestoraId: any[];
	public validar!: boolean;
	public dados = {
		nome: "",
		descricao: "",
		unidadeGestora: [] as IUnidadeGestoraModel[],
		amostraQuestoes: [] as IPlanejamentoAmostraMatrizQuestaoModel[],
		arrayFiles: [],
		amostraFormulario: null as IAmostraFormulario | null,
		tamanhoUniverso: 0,
		tamanhoAmostra: 0,
	};

	public model = {} as IAmostraModel;
	public tipoAmostra!: string;
	public numeroOpa: string;
	public tipoTrabalho: number;
	public visualizar: boolean = false;

	public ugDataSource = new MatTableDataSource<IUnidadeGestoraModel>([]);
	public ugSemDados = true;
	public matrizSelecionada: string = "";
	public titulo: string = "";
	public dropdownDataMatriz: { value: string; text: string }[] = [];
	public dropdownDataMatrizQuestoesPlanejamento: {
		value: string;
		text: string;
	}[] = [];
	selectedQuestoesMatriz: string[] = [];
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	resultado: string = "";
	erros: string[] = [];

	constructor(
		route: ActivatedRoute,
		toastr: ToastrService,
		router: Router,
		localeService: BsLocaleService,
		public matDialog: MatDialog,
		private ugService: SolicitacaoTecnicaService,
		private amostraService: AmostraService,
		@Inject(MAT_DIALOG_DATA) public data
	) {
		super(route, toastr, router, localeService, matDialog);
		this.id = data.id;
		console.log(data.dados);
		this.tipoTrabalho = parseInt(data.tipoTrabalho);
		if (data.dados) this.model = data.dados;
		if (data.tipoAmostra) this.tipoAmostra = data.tipoAmostra;
		if (data.visualizar) this.visualizar = data.visualizar;
		if (data.numeroOpa) this.numeroOpa = data.numeroOpa;
	}

	ngOnInit(): void {
		this.dados.nome = this.model.nome || "";
		this.dados.descricao = this.model.descricao || "";

		if (this.visualizar) {
			this.titulo = "Visualizar";
		} else if (this.model.id !== undefined && !this.visualizar) {
			this.titulo = "Editar";
		} else {
			this.titulo = "Adicionar";
		}

		if (this.model.amostraFormulario !== null) {
			this.dados.amostraFormulario = this.model.amostraFormulario;
		}

		if (
			this.model.amostraArquivos &&
			this.model.amostraArquivos.length > 0
		) {
			this.dados.arrayFiles = this.model.amostraArquivos;
		} else {
			this.dados.arrayFiles = [];
		}

		this.dados.tamanhoUniverso = this.model.tamanhoUniverso || 0;
		this.dados.tamanhoAmostra = this.model.tamanhoAmostra || 0;

		if (this.model.planejamentoAmostraMatrizQuestoes?.length > 0) {
			this.matrizSelecionada = String(
				this.model.planejamentoAmostraMatrizQuestoes[0]
					.matrizPlanejamentoId
			);
			this.montaComboMatrizPlanejamento();
			this.montaComboMatrizPlanejamentoQuestoesComSelecao();
		} else {
			this.selectedQuestoesMatriz = [];
		}

		if (
			this.model.amostraUnidadeGestoras &&
			this.model.amostraUnidadeGestoras.length > 0
		) {
			const formatPeaUnidadeGestora =
				this.model.amostraUnidadeGestoras.map((item) => {
					return {
						id: item?.unidadeGestoraId,
						text: `${item?.unidadeGestora?.sigla} - ${item?.unidadeGestora?.nome}`,
						value: item?.unidadeGestoraId,
					} as IUnidadeGestoraModel;
				});

			this.dados.unidadeGestora = formatPeaUnidadeGestora;
			this.atualizarListaUgs(formatPeaUnidadeGestora);
		} else {
			this.dados.unidadeGestora = [];
			this.atualizarListaUgs([]);
			this.montaComboMatrizPlanejamento();
		}
	}

	excluirFormulario(): void {
		this.dados.amostraFormulario = null;
	}

	public abrirModalFormulario(visualizar?: boolean) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = "modal-component-amostra-formulario";
		dialogConfig.width = "60vw";
		dialogConfig.maxHeight = "85vh";
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = false;
		dialogConfig.data = {
			nomeAmostra: this.dados.nome,
			visualizar: visualizar,
			dados: this.dados.amostraFormulario ?? null,
		};
		const modal = this.matDialog.open(
			ModalAmostraFormularioComponent,
			dialogConfig
		);
		modal.afterClosed().subscribe((data) => {
			if (data !== undefined) {
				this.dados.amostraFormulario = data;
			}
		});
	}

	private montaComboMatrizPlanejamentoQuestoesComSelecao(): void {
		const ids = this.model.amostraUnidadeGestoras.map((ug: any) => Number(ug.unidadeGestoraId
		));
		console.log(ids);
		this.amostraService
			.montaComboMatrizQuestoes(parseInt(this.matrizSelecionada), this.id)
			.then((res) => {
				if (res.sucesso) {
					this.dropdownDataMatrizQuestoesPlanejamento = this.dropdownDataMatrizQuestoesPlanejamento = res.dados
						.filter((item: any) => ids.includes(Number(item.unidadeGestoraId)))
						.map((item: any) => ({
							...item,
							custom: `${item.ordem} - ${item.text}`
						}));

					console.log(this.model.planejamentoAmostraMatrizQuestoes);
					const questoesValidas: string[] =
						this.model.planejamentoAmostraMatrizQuestoes.map((q) =>
							String(q.questaoId)
						);

					this.selectedQuestoesMatriz = questoesValidas.filter((id) =>
						res.dados.some((q) => q.value === id.toString())
					);
					const amostraIdValue =
						this.model.id && this.model.id !== 0
							? this.model.id
							: 0;

					this.dados.amostraQuestoes =
						this.selectedQuestoesMatriz.map((id) => ({
							id: 0,
							amostraId: amostraIdValue,
							questaoId: parseInt(id),
							matrizPlanejamentoId: parseInt(
								this.matrizSelecionada
							),
						}));
				}
			});
	}

	public atualizarListaUgs(unidadeGestora: IUnidadeGestoraModel[]) {
		const listaUgs = unidadeGestora.map((_) => ({
			..._,
			nome: `${_.sigla} - ${_.nome}`,
		}));
		this.ugDataSource.paginator = this.paginator;
		this.ugDataSource.sort = this.sort;
		this.ugDataSource.filterPredicate = (
			data: { nome: string },
			filterValue: string
		) => {
			return (
				(data.nome || "").trim().toLowerCase().indexOf(filterValue) !==
				-1
			);
		};
		listaUgs.sort((a, b) => a["nome"].localeCompare(b["nome"]));
		this.ugDataSource = new MatTableDataSource<IUnidadeGestoraModel>(
			listaUgs
		);
		this.ugDataSource.sortingDataAccessor = defaultDataAcessor;
		this.ugDataSource._updateChangeSubscription();
		this.ugSemDados = this.ugDataSource.filteredData.length === 0;
	}

	public async exibirModalUg() {
		const res = await this.ugService.obterUnidadeGestora(
			this.tipoAmostra,
			this.id
		);

		if (res.sucesso) {
			const dialogConfig = new MatDialogConfig();
			dialogConfig.id = "modal-component-45";
			dialogConfig.width = "650px";
			dialogConfig.hasBackdrop = true;
			dialogConfig.disableClose = true;

			const unidadesAdicionadas = [] as any[];
			if (this.dados.unidadeGestora !== undefined) {
				this.dados.unidadeGestora.forEach((d) => {
					return unidadesAdicionadas.push(d);
				});

				const ugs = res.dados.filter(
					(d) => !unidadesAdicionadas.some((x) => +d?.value == x?.id)
				);
				dialogConfig.data = {
					data: ugs,
					params: "amostra-modal",
				};
			} else {
				dialogConfig.data = {
					data: res.dados,
					params: "amostra-modal",
				};
				this.dados.unidadeGestora = [] as IUnidadeGestoraModel[];
			}
			const modal = this.matDialog.open(
				ModalSelecionarUgComponent,
				dialogConfig
			);
			modal.afterClosed().subscribe((data) => {
				if (data) {
					if (Array.isArray(data)) {
						let unidadeSelecionada = [] as IUnidadeGestoraModel[];
						unidadeSelecionada = data.map(
							(d) =>
								({
									value: d.value,
									text: d.text,
								} as IUnidadeGestoraModel)
						);
						unidadeSelecionada.forEach((x) =>
							this.dados.unidadeGestora.push(x)
						);
					}

					this.atualizarListaUgs(this.dados.unidadeGestora);
				}
			});
		} else {
			Swal.fire({
				toast: true,
				position: "top-end",
				icon: "error",
				text: res.mensagem.descricao,
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			});
		}
	}

	public excluirUg(ind: number) {
		this.ugDataSource.data.splice(ind, 1);
		this.dados.unidadeGestora.splice(ind, 1);
		this.atualizarListaUgs(this.dados.unidadeGestora);
	}

	public deleteFile(i: number) {
		if (this.dados.arrayFiles[i]) this.dados.arrayFiles.splice(i, 1);
	}

	public getBase64(file) {
		return new Promise((resolve, reject) => {
			var reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function () {
				resolve(reader.result);
			};
			reader.onerror = function (error) {
				Swal.fire({
					toast: true,
					position: "top-end",
					icon: "error",
					text:
						"Ocorreu um erro ao selecionar o arquivo" +
						error.toString(),
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
				});
			};
		});
	}

	public montaComboMatrizPlanejamento() {
		this.amostraService
			.montaComboMatriz(this.tipoTrabalho, this.id)
			.then((res) => {
				if (res.sucesso) {
					this.dropdownDataMatriz = res.dados;
				}
			});
	}

	public onSelectionChange() {
		if (this.matrizSelecionada !== "") {
			this.montaComboMatrizPlanejamentoQuestoes();
		}
	}

	public montaComboMatrizPlanejamentoQuestoes() {

		const ids = this.dados.unidadeGestora.map((ug: any) => Number(ug.value));
		this.amostraService
			.montaComboMatrizQuestoes(parseInt(this.matrizSelecionada), this.id)
			.then((res) => {
				if (res.sucesso) {
					this.dropdownDataMatrizQuestoesPlanejamento = res.dados
						.filter((item: any) => ids.includes(Number(item.unidadeGestoraId)))
						.map((item: any) => ({
							...item,
							custom: `${item.ordem} - ${item.text}`
						}));
				}
			});
	}

	onChangeMatrizQuestoes(): void {
		const novasQuestoesIds = this.selectedQuestoesMatriz.map((id) =>
			Number(id)
		);

		// Remove questões que não estão mais selecionadas
		this.dados.amostraQuestoes = this.dados.amostraQuestoes.filter((q) =>
			novasQuestoesIds.includes(q.questaoId)
		);

		// Adiciona novas questões que ainda não existem na lista
		novasQuestoesIds.forEach((questaoId) => {
			const existe = this.dados.amostraQuestoes.some(
				(q) => q.questaoId === questaoId
			);
			if (!existe) {
				this.dados.amostraQuestoes.push({
					id: 0,
					amostraId: 0,
					questaoId: questaoId,
					matrizPlanejamentoId: parseInt(this.matrizSelecionada),
				});
			}
		});

		console.log(novasQuestoesIds);
	}

	public async uploadAmostra(e: Event): Promise<void> {
		const input = e.target as HTMLInputElement;
		if (!input.files || input.files.length === 0) return;

		const file = input.files[0]; // Apenas um arquivo

		const maxSizeMB = 28;

		// Validação do tamanho
		if (file.size > maxSizeMB * 1024 * 1024) {
			this.exibirMensagemAlerta(
				`O arquivo selecionado excede o limite permitido.
			O sistema aceita apenas arquivos com tamanho máximo de ${maxSizeMB}MB.
			Por favor, selecione um arquivo dentro do limite.`,
				false,
				"Erro de Tamanho"
			);
			return;
		}
		const ext = file.name.split(".").pop()?.toLowerCase();

		const tiposValidos = ["csv", "xls", "xlsx"];

		if (!ext || !tiposValidos.includes(ext)) {
			this.exibirMensagemAlerta(
				'Formato do arquivo diferente: "O arquivo selecionado não é aceito.' +
					" O sistema permite apenas arquivos nos formatos csv e/ou xls e/ou xlsx." +
					" Por favor, selecione um arquivo válido.",
				false,
				"Erro de Tipo"
			);
			return;
		}

		// Lê o arquivo para análise
		const data = await file.arrayBuffer();

		let workbook;
		if (ext === "csv") {
			// Para csv, converte o arquivo para string e cria planilha com XLSX.utils.csv_to_sheet
			const text = await file.text();
			const sheet = XLSX.read(text, { type: "string" }).Sheets.Sheet1;
			workbook = {
				SheetNames: ["CSV"],
				Sheets: {
					CSV: sheet,
				},
			};
		} else {
			// Para xls/xlsx, lê normalmente
			workbook = XLSX.read(data, { type: "array" });
		}

		const primeiraPlanilha = workbook.SheetNames[0];
		const sheet = workbook.Sheets[primeiraPlanilha];

		// Verifica linhas inválidas nas colunas A e B (1 a 30)
		const linhasInvalidas: string[] = [];
		let maxLinha = 0;

		for (const cellAddress in sheet) {
			if (sheet.hasOwnProperty(cellAddress)) {
				const match = cellAddress.match(/^([AB])(\d+)$/);
				if (match) {
					const linha = parseInt(match[2], 10);
					if (linha > maxLinha) {
						maxLinha = linha;
					}
				}
			}
		}

		for (let i = 1; i <= maxLinha; i++) {
			const aCell = sheet[`A${i}`]?.v;
			const bCell = sheet[`B${i}`]?.v;

			const aTemValor =
				aCell !== undefined && aCell !== null && aCell !== "";
			const bTemValor =
				bCell !== undefined && bCell !== null && bCell !== "";

			const erros: string[] = [];

			if (!aTemValor && bTemValor) {
				erros.push("Coluna A está vazia");
			}

			if (aTemValor && !bTemValor) {
				erros.push("Coluna B está vazia");
			}

			if (erros.length > 0) {
				linhasInvalidas.push(`Linha ${i}: ${erros.join(". ")}.`);
			}
		}

		if (linhasInvalidas.length === 0) {
			this.resultado = "Todas as linhas da planilha estão corretas.";
			this.erros = [];

			const fileToArray = await this.getBase64(file);
			this.dados.arrayFiles.push({
				nome: file.name,
				conteudo: fileToArray.toString(),
			});
		} else {
			const linhas = linhasInvalidas
				.map((linha) => linha.match(/\d+/)?.[0])
				.filter(Boolean);

			this.resultado = `Erro nas linhas: ${linhas.join(", ")}`;
			this.erros = linhasInvalidas;

			const mensagem =
				"Arquivo Inválido!<br>" + linhasInvalidas.join("<br>");
			this.exibirMensagemAlerta(mensagem, true, "Validação de Arquivo");
		}
	}

	get desabilitaInputFile(): boolean {
		return this.dados?.arrayFiles?.length >= 1;
	}

	get desabilitaPreencher(): boolean {
		return this.dados?.amostraFormulario == null;
	}

	public salvar() {
		if (!this.dados.nome || !this.dados.descricao) {
			this.validar = true;
			Swal.fire({
				toast: true,
				position: "top-end",
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
				icon: "warning",
				text: "Preencha os campos obrigatórios",
			});
			return;
		}

		this.model.nome = this.dados.nome;
		this.model.descricao = this.dados.descricao;
		this.model.amostraArquivos = this.dados.arrayFiles;
		this.model.tamanhoUniverso = this.dados.tamanhoUniverso;
		this.model.tamanhoAmostra = this.dados.tamanhoAmostra;
		this.model.planejamentoAmostraMatrizQuestoes =
			this.dados.amostraQuestoes;

		this.model.amostraFormulario = this.dados.amostraFormulario;

		this.model.amostraUnidadeGestoras = this.dados.unidadeGestora.map(
			(item) => {
				return {
					unidadeGestoraId: +item.value,
				} as IAmostraUnidadeGestora;
			}
		);


		this.amostraService
			.salvarAmostra(this.id, this.model, this.tipoAmostra)
			.then((res) => {
				if (res.sucesso) {
					Swal.fire({
						toast: true,
						position: "top-end",
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
						icon: "success",
						text: res.mensagem.descricao,
					});

					// Aguarda a tabela ser atualizada antes de fechar
					setTimeout(() => {
						this.matDialog.closeAll();
					}, 200); // pequeno delay
				} else {
					Swal.fire({
						toast: true,
						position: "top-end",
						showConfirmButton: false,
						timer: 5000,
						timerProgressBar: true,
						icon: "error",
						text: res.mensagem.descricao,
					});
				}
			})
			.catch((err) => {
				Swal.fire({
					toast: true,
					position: "top-end",
					showConfirmButton: false,
					timer: 5000,
					timerProgressBar: true,
					icon: "error",
					text: err.mensagem.descricao,
				});
			});
	}

	public cancelar() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.data = { interno: true };

		if (this.visualizar) {
			this.matDialog.closeAll();
		} else {
			this.matDialog
				.open(ModalCancelarComponent, dialogConfig)
				.afterClosed();
		}
	}
}
